import { render } from "./GenderPicker.vue?vue&type=template&id=268ef312&ts=true"
import script from "./GenderPicker.vue?vue&type=script&lang=ts"
export * from "./GenderPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__